import React, { useContext, useEffect, useState } from 'react';
import ColorListBox from '../ColorsListBody';
import SummaryBar from '../SummaryBar';
import { connect } from 'react-redux';
import { WardrobesConfigsContext } from '../../contexts/WardrobesConfigsContext';
import { ActiveWardrobeContext } from '../../contexts/ActiveWardrobeContext';
import { WardrobeHeightContext } from '../../contexts/WardrobeHeightContext';
import { PriceContext } from '../../contexts/PriceContext';
import { getAccessories } from '../../store/actions/accessories';
import { getAddons } from '../../store/actions/addons';
import { useHistory } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import calculatePrice from '../../helpers/calculatePrice';
import Loader from '../Loader';
import { rebuildFronts } from '../../helpers/wardrobe';
import { toast, ToastContainer } from 'react-toastify';
import { isDeclared } from 'helpers/helpers';
import { GAContext } from 'contexts/GAContext';
import PopUp from '../popup/PopUp';
import Currency from 'react-currency-formatter';
import getWardrobeType from 'helpers/getWardrobeType';

const notify = () => {
  toast.error('Wybierz drzwi w celu doboru uchwytów', {
    closeOnClick: true,
    position: 'top-right',
    autoClose: 10000,
    toastId: 1, // show only one
  });
};

const SelectHandleColor = ({
  wardrobe,
  activeFront,
  activeColor,
  setHandleMaterial,
  handleList,
}) => {
  const openPopup = () => {
    const popup = document.querySelector(`[data-popup-name="handles-photography"]`);
    if (!!popup) {
      popup.classList.add('open');
    }
  };

  let label = null;

  if (wardrobe.is_hinged) {
    label = `Uchwyt dla drzwi: ${activeFront && activeColor ? activeColor.name : ''}`;
  } else {
    label = `Kolor: ${activeFront && activeColor !== null ? activeColor.name : ''}`;
  }

  return (
    <ColorListBox
      title={label}
      activeValue={activeFront ? (activeColor !== null ? activeColor.safo : null) : null}
      changeMaterial={activeFront ? setHandleMaterial : () => notify()}
      colorsList={handleList}
      popupFunc={openPopup}
    />
  );
};

const HandlesConfig = props => {
  const {
    setOpenDoorsState,
    activeFront,
    setActiveFrontsPanels,
    addonsList,
    getAddons,
    frontGroupList,
    fronts,
  } = props;

  const { wardrobeHeight } = useContext(WardrobeHeightContext);
  const { wardrobesConfigs, setWardrobesConfigs } = useContext(WardrobesConfigsContext);
  const { activeWardrobe } = useContext(ActiveWardrobeContext);
  const { setPrice } = useContext(PriceContext);
  const { GA } = useContext(GAContext);

  const wardrobe = wardrobesConfigs[activeWardrobe];
  const isSliding = !wardrobe.is_hinged;
  const history = useHistory();
  const summaryCopy = reactLocalStorage.getObject('summaryCopy');
  const onlyOneHandle = ['C627', 'C630', 'C501'];

  const [handleState, setHandleState] = useState({
    activeMat: {
      left: null,
      right: null,
    },
    isSliding: null,
    loaded: false,
    activeSide: 'left',
    panelActive: false,
  });

  const refColorList = React.useRef([]);

  useEffect(() => {
    if (wardrobe) {
      let activeFrontTmp = activeFront;
      if (!!!activeFront) {
        activeFrontTmp = 'Front_0_0';
      }

      let door = activeFrontTmp.split('_');
      let activeDoor = parseInt(door[1]);

      setHandleState({
        ...handleState,
        activeSide: activeDoor === 0 ? 'left' : 'right',
      });
    }
    /* eslint-disable-next-line */
  }, [activeFront]);

  useEffect(() => {
    if (wardrobe) {
      let frontsList = wardrobe.fronts;
      frontsList.map(front => {
        if (front && front.hasOwnProperty('safo')) {
          handleState.panelActive = true;
        }
        return front;
      });
    }
    /* eslint-disable-next-line */
  }, [frontGroupList]);

  const setTracks = value => {
    wardrobe.addons.track = addonsList.find(
      item => item.safo.includes('TOR') && item.safo.includes(value.safo.split('-').pop()),
    );
  };

  const setHandleMaterialForSliding = value => {
    if (!wardrobe.hasOwnProperty('addons')) {
      wardrobe.addons = {};
    }

    if (!wardrobe.addons.hasOwnProperty('track')) {
      wardrobe.addons.track = null;
    }

    setTracks(value);

    wardrobe.handles.left = value;
    wardrobe.handles.right = value;
  };

  const getPreviousHandle = (handles, chosenHandle) => {
    let handleList = [handles.left, handles.right];
    const handlePlytka = handleList.find(item => item?.safo?.includes('C416'));
    if (handlePlytka === undefined) {
      return chosenHandle;
    }
    const handle = handleList.find(item => onlyOneHandle.some(code => item.safo.includes(code)));

    if (handle !== undefined && handle !== null && handlePlytka.safo === chosenHandle.safo) {
      return handle;
    } else {
      return chosenHandle;
    }
  };

  const isGroup2Front = (side, handle, chosen) => {
    let needPlytka = false;
    const list = [...onlyOneHandle, 'C416'];
    if (chosen) {
      needPlytka = list.some(item => chosen.safo.includes(item));
    }

    if (handle && needPlytka === false) {
      needPlytka = list.some(item => handle.safo.includes(item));
    }
    return (
      wardrobe.fronts[side].safo.includes('SZK') ||
      wardrobe.fronts[side].safo.includes('LUS') ||
      needPlytka
    );
  };

  const setHandleMaterialForHinged = value => {
    let activeFrontTmp = activeFront;
    if (!!!activeFront) {
      activeFrontTmp = 'Front_0_0';
    }

    const door = activeFrontTmp.split('_');
    const activeDoor = parseInt(door[1]);
    const side = activeDoor === 0 ? 'left' : 'right';
    const oppositeSide = side === 'left' ? 'right' : 'left';

    let defaultHandle = value;
    const needPlytka = onlyOneHandle.some(item => value.safo.includes(item));

    const frontObj = wardrobe.fronts[activeDoor];

    const selectedPlate = value.safo.includes('C416');

    if (needPlytka || selectedPlate) {
      const isGlass =
        frontObj &&
        frontObj.safo &&
        (frontObj.safo.includes('SZK') || frontObj.safo.includes('LUS'));
      let handleTypeL = frontObj.linked.find(item => item.safo.includes(isGlass ? 'C501' : 'C627'));
      let handleTypePlytka = frontObj.linked.find(item => item.safo.includes('C416'));
      let leftHandle = null;
      let rightHandle = null;
      const handles = wardrobe.handles[oppositeSide];
      const beforeHandle = handles && handles.hasOwnProperty('safo') ? handles : defaultHandle;
      handleTypeL = getPreviousHandle(wardrobe.handles, defaultHandle);
      switch (wardrobe.dimensions.x) {
        case 50:
          wardrobe.handles.left = defaultHandle;
          break;
        case 75:
        case 100:
          leftHandle = wardrobe.handles['left'];
          rightHandle = wardrobe.handles['right'];

          if (activeDoor) {
            if (handleTypePlytka.safo === value.safo) {
              leftHandle = isGroup2Front(0, wardrobe.handles['left'], value)
                ? handleTypeL
                : beforeHandle;
              rightHandle = isGroup2Front(1, wardrobe.handles['right'], value)
                ? handleTypePlytka
                : beforeHandle;
            } else {
              leftHandle = isGroup2Front(0, wardrobe.handles['left'], value)
                ? handleTypePlytka
                : beforeHandle;
              rightHandle = isGroup2Front(1, wardrobe.handles['right'], value)
                ? handleTypeL
                : beforeHandle;
            }
          } else {
            if (handleTypePlytka.safo === value.safo) {
              leftHandle = isGroup2Front(0, wardrobe.handles['left'], value)
                ? handleTypePlytka
                : beforeHandle;
              rightHandle = isGroup2Front(1, wardrobe.handles['right'], value)
                ? handleTypeL
                : beforeHandle;
            } else {
              leftHandle = isGroup2Front(0, wardrobe.handles['left'], value)
                ? handleTypeL
                : beforeHandle;
              rightHandle = isGroup2Front(1, wardrobe.handles['right'], value)
                ? handleTypePlytka
                : beforeHandle;
            }
          }

          if (leftHandle.safo.includes('C416') && rightHandle.safo.includes('C416')) {
            if (activeDoor) {
              leftHandle = beforeHandle;
            } else {
              rightHandle = beforeHandle;
            }
          }

          wardrobe.handles.left = leftHandle;
          wardrobe.handles.right = rightHandle;
          break;
        case 103:
        case 66:
        case 97:
          wardrobe.handles[side] = defaultHandle;
          break;

        default:
          break;
      }
    } else {
      if (isDeclared(defaultHandle)) {
        wardrobe.handles[side] = defaultHandle;
        if (wardrobe.doors > 1) {
          let handlesL = props.handlesList.find(item =>
            onlyOneHandle.some(code => item.safo.includes(code)),
          );
          let doorType = {
            left: isGroup2Front(1),
            right: isGroup2Front(0),
          };

          if (activeDoor) {
            wardrobe.handles.right = doorType.left ? handlesL : defaultHandle;
          } else {
            wardrobe.handles.left = doorType.right ? handlesL : defaultHandle;
          }
        }
      }
    }

    return side;
  };

  const setHandleMaterial = value => {
    let side = 'left';
    if (isSliding) {
      setHandleMaterialForSliding(value);
    } else {
      side = setHandleMaterialForHinged(value);
    }

    setHandleState({
      ...handleState,
      activeSide: side,
      activeMat: wardrobe.handles,
    });

    wardrobesConfigs[activeWardrobe] = wardrobe;
    setWardrobesConfigs(wardrobesConfigs);
    setPrice(calculatePrice(wardrobesConfigs[activeWardrobe]));
    GA('Handles configuration', 'Select handles of wardrobe');
  };

  const findColor = (color, isSliding = null) => {
    let sliding = isSliding;
    sliding = isSliding === null ? isSliding : sliding;

    return refColorList.current.find(item => {
      if (sliding) {
        return item.safo.includes(color) && item.dimensions.y === wardrobeHeight;
      } else {
        return item.safo.includes(color);
      }
    });
  };

  const setDefaultHandles = isSliding => {
    const type = isSliding ? 7 : 8;
    let activeMat = { left: null, right: null };

    if (props?.defaultHandles?.[type]?.handles?.hasOwnProperty('left')) {
      activeMat = {
        left: findColor(props.defaultHandles[type].handles.left, isSliding),
        right: findColor(props.defaultHandles[type].handles.right, isSliding),
      };
    }

    const nullish = value => {
      return value ?? null;
    };

    if (nullish(activeMat.left) !== null) {
      if (getWardrobeType(wardrobe) == 'F57-SZF-PRZES' && wardrobe.addons?.track) {
        // eslint-disable-next-line
        console.log('wyjątek, nie nadpisuje toru');
      } else {
        setTracks(activeMat.left);
      }
    }

    if (nullish(wardrobe.handles.left) !== null && nullish(wardrobe.handles.right) !== null) {
      activeMat = wardrobe.handles;
    }

    return activeMat;
  };

  useEffect(() => {
    if (!handleState.loaded) {
      let params = {
        ...handleState,
        loaded: true,
        isSliding: isSliding,
        activeMat: setDefaultHandles(isSliding),
      };

      let tmpColorsList = props.handlesList;
      if (!isSliding) {
        tmpColorsList = [...wardrobesConfigs[activeWardrobe].fronts[0].linked];
      }

      tmpColorsList = tmpColorsList.filter(item => {
        return isSliding ? item.dimensions.y === wardrobeHeight : item.types.hasOwnProperty(8);
      });

      refColorList.current = tmpColorsList;

      setHandleState(params);
      setOpenDoorsState(false);

      wardrobesConfigs[activeWardrobe].handles = params.activeMat;
      setWardrobesConfigs(wardrobesConfigs);
      if (isSliding) {
        getAddons(wardrobe.dimensions.x);
      }
    }
    /* eslint-disable-next-line */
  }, [activeWardrobe]);

  useEffect(() => {
    if (wardrobe.is_hinged) {
      if (activeFront !== undefined) {
        let door = activeFront.split('_');
        let doorId = parseInt(door[1]);
        if (doorId !== undefined) {
          if (
            wardrobe.hasOwnProperty('fronts') &&
            wardrobe.fronts.hasOwnProperty(doorId) &&
            wardrobe.fronts[doorId].hasOwnProperty('linked')
          ) {
            let handlesAssignedToFront = wardrobe.fronts[doorId].linked;
            refColorList.current = [...handlesAssignedToFront];
          }
          setActiveFrontsPanels(['Front_' + door[1] + '_' + door[2]]);
        }
      }
    }
    /* eslint-disable-next-line */
  }, [activeFront]);

  useEffect(() => {
    const isSliding = !wardrobe.is_hinged;

    let params = {
      ...handleState,
      loaded: true,
      isSliding: isSliding,
      activeMat: setDefaultHandles(isSliding),
    };
    setHandleState(params);

    let wardrobesConfigsTmp = [...wardrobesConfigs];
    wardrobesConfigsTmp[activeWardrobe].handles = params.activeMat;

    if (!wardrobe.is_hinged) {
      const panelsCnt = wardrobesConfigsTmp[activeWardrobe].panels;
      const frontsList = wardrobesConfigsTmp[activeWardrobe].fronts;
      const frn = rebuildFronts(frontsList, panelsCnt, fronts);
      wardrobesConfigs[activeWardrobe].fronts = frn;
    }

    setWardrobesConfigs(wardrobesConfigs);
    if (wardrobesConfigs[activeWardrobe].dimensions.x < 120) {
      setActiveFrontsPanels(['Front_0_0']);
    }
    /* eslint-disable-next-line */
  }, [activeWardrobe]);

  const accessoriesStart = () => {
    if (summaryCopy.length >= 1) {
      reactLocalStorage.remove('summaryCopy');
    }
    history.push('/accessories-configuration');
  };

  let activeColor =
    !!handleState.activeMat[handleState.activeSide] &&
    handleState.activeMat[handleState.activeSide].hasOwnProperty('safo')
      ? handleState.activeMat[handleState.activeSide]
      : null;

  useEffect(() => {
    if (wardrobesConfigs[activeWardrobe].is_hinged && !wardrobesConfigs[activeWardrobe].is_corner) {
      if (wardrobesConfigs[activeWardrobe].dimensions.x > 50) {
        if (refColorList.current[0] !== undefined) {
          const wardrobeHandles = wardrobesConfigs[activeWardrobe].handles;
          const condition = ['LUS', 'SZK'];
          const leftDoor = condition.some(el => wardrobe.fronts[0].safo.includes(el));
          const rightDoor = condition.some(el => wardrobe.fronts[1].safo.includes(el));
          const handleTypeL = wardrobe.fronts[0].linked.find(item => item.safo.includes('C501'));
          const handleTypeR = wardrobe.fronts[1].linked.find(item => item.safo.includes('C501'));
          const handleTypePlytka = wardrobe.fronts[1].linked.find(item =>
            item.safo.includes('C416'),
          );
          const handleGalkaLeft = wardrobe.fronts[0].linked.find(item =>
            item.safo.includes('C475'),
          );
          const handleGalkaRight = wardrobe.fronts[1].linked.find(item =>
            item.safo.includes('C475'),
          );

          if (leftDoor && !rightDoor) {
            wardrobe.handles = {
              left: wardrobeHandles.left ? wardrobeHandles.left : handleTypeL,
              right: wardrobeHandles.right ? wardrobeHandles.right : handleGalkaRight,
            };
          }
          if (rightDoor && !leftDoor) {
            wardrobe.handles = {
              left: wardrobeHandles.left ? wardrobeHandles.left : handleGalkaLeft,
              right: wardrobeHandles.right ? wardrobeHandles.right : handleTypeR,
            };
          }
          if (leftDoor && rightDoor) {
            wardrobe.handles = {
              left: wardrobeHandles.left ? wardrobeHandles.left : handleTypeL,
              right: wardrobeHandles.right ? wardrobeHandles.right : handleTypePlytka,
            };
          }
          if (!leftDoor && !rightDoor) {
            wardrobe.handles = {
              left: wardrobeHandles.left ? wardrobeHandles.left : refColorList.current[1],
              right: wardrobeHandles.right ? wardrobeHandles.right : refColorList.current[1],
            };
          }
        }
      }
    }
    if (wardrobesConfigs[activeWardrobe].doors === 1) {
      if (refColorList.current[0] !== undefined) {
        const condition = ['LUS', 'SZK'];
        const leftDoor = condition.some(el => wardrobe.fronts[0].safo.includes(el));
        const handleTypeL = wardrobe.fronts[0].linked.find(item => item.safo.includes('C501'));
        if (leftDoor) {
          wardrobe.handles = {
            left: handleTypeL,
          };
        } else {
          wardrobe.handles = {
            left: refColorList.current[1],
          };
        }
      }
    }
    setHandleState({
      ...handleState,
      activeMat: wardrobe.handles,
    });
    setPrice(calculatePrice(wardrobesConfigs[activeWardrobe]));
    /* eslint-disable-next-line */
  }, [refColorList.current.length]);

  const handleList = () => {
    let colorsListTmp = [];
    if (
      wardrobesConfigs[activeWardrobe].is_hinged &&
      wardrobesConfigs[activeWardrobe].doors === 1
    ) {
      colorsListTmp = refColorList.current.filter(item => !item.safo.includes('C416'));
    } else {
      colorsListTmp = refColorList.current;
    }

    colorsListTmp = colorsListTmp.sort((a, b) => {
      return a.safo.localeCompare(b.safo);
    });

    return colorsListTmp;
  };

  const generatedHandleList = handleList();

  return (
    <div>
      {!wardrobesConfigs[activeWardrobe].is_corner &&
      wardrobesConfigs[activeWardrobe].dimensions.x > 100 ? (
        <div className="container__text container__text--position-2">
          <p>Wybierz kolor uchwytów.</p>
        </div>
      ) : (
        <div className="container__text container__text--position-2">
          <p>Wybierz drzwi w celu doboru uchwytów.</p>
        </div>
      )}
      <div className="container handles-config">
        {refColorList.current.length ? (
          <SelectHandleColor
            wardrobe={wardrobe}
            activeFront={activeFront}
            activeColor={activeColor}
            setHandleMaterial={setHandleMaterial}
            handleList={generatedHandleList}
            colorsList={refColorList.current}
            defaultHandles={props.defaultHandles}
          />
        ) : (
          <Loader />
        )}

        <SummaryBar
          btnText="Przejdź dalej"
          btnIcon={true}
          btnFunction={accessoriesStart}
          propClass={refColorList.current.length ? 'active' : ''}
        />
      </div>
      <ToastContainer />
      <PopUp title="Informacje o uchwytach" popupName="handles-photography">
        <div className="handles-information">
          {generatedHandleList.map(item => (
            <div key={item.id} className="handles-information__box">
              <img src={item.icon ?? item.img} alt={item.name} />
              <p>{item.name}</p>
              <p>
                <Currency quantity={item.price.actual} currency="PLN" />
              </p>
            </div>
          ))}
        </div>
      </PopUp>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    handlesList: state.products.handlesColors,
    frontGroupList: state.products.frontsGroup,
    fronts: state.products.fronts,
    addonsList: state.addons.addons,
    defaultHandles: state.defaults.hull,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAddons: width => dispatch(getAddons(width)),
    getAccessories: (safo, width, depth) => dispatch(getAccessories(safo, width, depth)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HandlesConfig);
